module.exports = __webpack_public_path__ + "static/media/pdi-image-02.3108c8d9.svg";